import { render, staticRenderFns } from "./lottery-PK10.vue?vue&type=template&id=9f8e59ea&scoped=true"
import script from "./lottery-PK10.vue?vue&type=script&lang=js"
export * from "./lottery-PK10.vue?vue&type=script&lang=js"
import style0 from "./lottery-PK10.vue?vue&type=style&index=0&id=9f8e59ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8e59ea",
  null
  
)

export default component.exports